import { ImageDataNew } from "@shared_components/components/SmartImage";

// Internal
//export const FETCH_GEARSTUDIO_CONFIG_URL = "/api/config/";  not currently used. saved if needed later on with the order phase.
//  External
export const FETCH_GEARSTUDIO_TEMPLATES_URL = "/api/gearstudio/products/templates/";
export const FETCH_GEARSTUDIO_DESIGN_USAGE_URL = "/api/gearstudio/designs/usage-data/";
export const POST_GEARSTUDIO_NEW_DESIGN_URL = "/api/gearstudio/designs/generate-ai-design/";
export const FETCH_GEARSTUDIO_HISTORY_URL = "/api/gearstudio/designs/get-history/";
export const GEARSTUDIO_EDIT_PROMPT_URL = "/api/gearstudio/designs/edit-prompt/";
export const GEARSTUDIO_USER_IMAGES_URL = "/api/gearstudio/designs/user-images/";
export const GEARSTUDIO_GENERATE_USER_IMAGE_URL = "/api/gearstudio/designs/user-images/generate-ai/";
export const GEARSTUDIO_PANEL_IMAGES_URL = "/api/gearstudio/designs/panel-images/";
export const GEARSTUDIO_CREATE_ORDER_URL = "/api/gearstudio/orders/create-order/";
export const GEARSTUDIO_HANDLING_FEE_URL = "/api/cart/handling_fee/";
export const GEARSTUDIO_CALCULATE_CAPACITY_URL = "/api/calculate-capacity/";
// Compatibility fallback while Gearstudio endpoints are being rolled out on all environments.


export type GearStudioDesign = {
    id: number;
    user: string;
    name: string;
    product_template: GearstudioProduct;
    user_prompt: string;
    panels: GearStudioPanel[];
    created_at : Date; //this is formatted on serializer
    formatted_created_at: string; //this is formatted on serializer
    revision_number: number;
}

export type GearStudioPanel = {
    id: number;
    images_data : ImageDataNew;
    position: string;
    name: string;
    partkey: string;
    images: GearStudioImage[];
}


export type GearStudioImage = {
    id: number;
    images_data: ImageDataNew;
    x_position: number;
    y_position: number;
    scale: number;
    rotation: number;
    source_user_image_id?: number;
}

export type GearstudioUserImage = {
    id: number;
    name: string;
    images_data: ImageDataNew;
    created_at: string;
    updated_at: string;
}

export type UsageData = {
    usage_count: number;
    usage_reset_time: string;
    daily_limit: number;
}


export type GearstudioProduct = {
    id: number;
    name: string;
    product_price?: number;
    gltf_file: string;
    camera_positions: {
        x: number; // X position of the model in the scene
        y: number; // Y position of the model in the scene
        z: number; // Z position of the model in the scene
        zoom: number; // Zoom level for the model
    }
    object_positions: {
        scale: number;
        x: number;
        y: number;
        z: number;
    }
    ai_design_position?: {
        x_position: number;
        y_position: number;
        scale: number;
        rotation: number;
    },
    materials: GearstudioProductPanel[];
    updated_at: Date;
}

export type GearstudioProductPanel = {
    id: number;
    name: string;
    position: string;
    replaceable?: boolean; // Whether this material should be replaced with a panel
}

export type HandlingFeeRange = {
    fee_amount: number;
    min_order_value: number;
    max_order_value: number;
}

export type GearstudioPricing = {
    product_price: number;
    processing_fee: number;
    total_price: number;
}
